<template>
  <q-table
    :class="
      $q.dark.mode
        ? 'table-sticky-header-column-dark'
        : 'table-sticky-header-column'
    "
    dense
    :rows="buySell"
    :columns="columns"
    :pagination="pagination"
    row-key="date"
    style="width: 100%"
    separator="cell"
  >
    <template v-slot:body="props">
      <q-tr :props="props" :key="`e_${props.row.date}`">
        <q-td class="text-left">{{ props.row.date }}</q-td>

        <q-td class="text-center">
          <div
            class="week-counts cursor-pointer q-pa-sm"
            @click="
              () =>
                $router.push(
                  !$store.state.authenticate.isAuthenticated
                    ? {
                        name: 'Login',
                        query: {
                          route: 'WeeklySignal',
                          signal: 'buySignal',
                        },
                      }
                    : {
                        name: 'WeeklySignal',
                        query: {
                          signal: 'buySignal',
                        },
                      }
                )
            "
            :id="props.row?.date ? props.row.date + '_' + 'buy' : 'null'"
          >
            <q-badge v-if="props.row.buy_count" color="green">
              {{ props.row.buy_count }}

              <q-tooltip
                v-if="!$store.state.authenticate.isAuthenticated"
                :class="
                  !this.$q.dark.mode === true ? 'bg-green-4' : 'bg-gray-3'
                "
              >
                <div>Please Login</div>
              </q-tooltip>
            </q-badge>
            <q-badge v-else color="white" id="null" style="color: black">
              --
            </q-badge>
          </div>
        </q-td>
        <q-td class="text-center">
          <div
            class="week-counts cursor-pointer"
            @click="
              () =>
                $router.push(
                  !$store.state.authenticate.isAuthenticated
                    ? {
                        name: 'Login',
                        query: {
                          route: 'WeeklySignal',
                          signal: 'sellSignal',
                        },
                      }
                    : {
                        name: 'WeeklySignal',
                        query: {
                          signal: 'sellSignal',
                        },
                      }
                )
            "
            :id="props.row?.date ? props.row.date + '_' + 'sell' : 'null'"
          >
            <q-badge
              v-if="props.row.sell_count"
              :id="props.row?.date ? props.row.date + '_' + 'sell' : 'null'"
              color="red"
            >
              {{ props.row.sell_count }}

              <q-tooltip
                v-if="!$store.state.authenticate.isAuthenticated"
                :class="!this.$q.dark.mode === true ? 'bg-red-3' : 'bg-gray-3'"
              >
                <div>Please Login</div>
              </q-tooltip>
            </q-badge>
            <q-badge v-else color="white" id="null" style="color: black">
              --
            </q-badge>
          </div>
        </q-td>
      </q-tr>
    </template>
  </q-table>
</template>

<script>
import { useStore } from "vuex";
import { defineComponent, ref, onMounted, onUnmounted } from "vue";

export default defineComponent({
  name: "SignalsCount",
  props: {
    buySell: {
      type: Array,
    },
    signalPreview: {
      type: Array,
      required: true,
      default() {
        return ["Not generated"];
      },
    },
  },
  emits: ["signalHover"],
  setup(props, context) {
    const store = useStore();

    const columns = [
      {
        label: "Date",
        name: "date",
        field: "date",
        required: true,
        align: "left",
      },
      // {
      //   label: "Early Buy",
      //   name: "early_buy_count",
      //   field: "early_buy_count",
      //   align: "center",
      // },
      // {
      //   label: "Early Sell",
      //   name: "early_sell_count",
      //   field: "early_sell_count",
      //   align: "center",
      // },
      {
        label: "Green Signal",
        name: "buy_count",
        field: "buy_count",
        align: "center",
      },
      {
        label: "Red Signal",
        name: "sell_count",
        field: "sell_count",
        align: "center",
      },
    ];

    const pagination = ref({
      sortBy: "date",
      descending: true,
      rowsPerPage: 8,
    });

    const onSignalhover = (event) => {
      if (event.target?.id) {
        context.emit("signalHover", event.target);
      }
    };

    onMounted(() => {
      window.addEventListener("mouseover", onSignalhover);
    });

    onUnmounted(() => window.removeEventListener("mouseover", onSignalhover));

    return { columns, onSignalhover, pagination };
  },
});
</script>
